import React, { useState } from 'react';
import {
  IonPage,
  IonContent,
  IonCard,
  IonCardContent,
  IonItem,
  IonInput,
  IonButton,
  IonCheckbox,
  IonText,
  IonLoading,
  useIonRouter,
  IonFooter,
} from '@ionic/react';

import './AuthPage.css';
import { authStaff } from '../../../entities/auth';
import { setData } from '../../../core/preference';

const AuthPage: React.FC = () => {
  const router = useIonRouter()
  const [restaurantId, setRestaurantId] = useState<number>();
  const [login, setLogin] = useState<any>();
  const [password, setPassword] = useState<any>();
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async () => {
    // e.preventDefault();
    setIsLoading(true)
    const data ={
      login: login,
      password: password,
      restaurantCode: restaurantId
    }
    console.log(data)
    try {
      const res = await authStaff(data)
      setData('token',res.access_token)
      router.push('/tabs',"root", "replace")
    } catch (error) {
      setError('Неверный логин или пароль')
      console.log(error)
    }finally{
      setIsLoading(false)
    }
    
    // здесь твоя логика авторизации
    // setError('Неверный логин или пароль');
  };

  //  useIonViewDidEnter(() => {
  //   console.log('ionViewDidEnter event fired');
  // });

  // useIonViewDidLeave(() => {
  //   console.log('ionViewDidLeave event fired');
  // });

  // useIonViewWillEnter(() => {
  //   console.log('ionViewWillEnter event fired');
  // });

  // useIonViewWillLeave(() => {
  //   console.log('ionViewWillLeave event fired');
  // });

  
  return (
    <IonPage>
      <IonContent fullscreen className="login-content">
         <IonLoading
          isOpen={isLoading}
          message="Входим..."
          spinner="crescent"
        />
        <div className="login-wrapper2 flex h-full w-full flex-col items-center justify-center">
          <IonCard className="login-card2 shadow-sm">
            <IonCardContent>
              <div className="login-icon">
                <span role="img" aria-label="restaurant">
                  🍽️
                </span>
              </div>

              <h1 className="login-title">Добро пожаловать</h1>
              <p className="login-subtitle">
                Войдите в систему для продолжения работы
              </p>

                <div className="login-field-label">ID ресторана</div>
                <IonItem lines="none" className="login-item">
                  <IonInput
                    
                    placeholder="Введите ID ресторана"
                    value={restaurantId?.toString()}
                    onIonInput={(e) => setRestaurantId(Number(e.detail.value))}
                  />
                </IonItem>

                <div className="login-field-label">Логин</div>
                <IonItem lines="none" className="login-item">
                  <IonInput
                    placeholder="Введите логин"
                    value={login}
                    onIonInput={(e) => {setLogin(e.detail.value);console.log(e.detail.value)}}
                  />
                </IonItem>

                <div className="login-field-label">Пароль</div>
                <IonItem lines="none" className="login-item">
                  <IonInput
                    type="password"
                    placeholder="Введите пароль"
                    // value={password}
                    onIonInput={(e) => setPassword(e.detail.value)}
                  />
                </IonItem>

                <div className="login-row">
                  {/* <label className="remember-me">
                    <IonCheckbox
                      checked={rememberMe}
                      onIonChange={(e) => setRememberMe(e.detail.checked)}
                    />
                    <span>Запомнить меня</span>
                  </label> */}

                  {/* <button
                    type="button"
                    className="login-forgot"
                    onClick={() => console.log('forgot password')}
                  >
                    Забыли пароль?
                  </button> */}
                </div>

                {error && (
                  <div className="login-error">
                    <IonText color="light">
                      <span>Неверный логин или пароль</span>
                    </IonText>
                  </div>
                )}
            </IonCardContent>
          </IonCard>
        </div>
        
      </IonContent>
      <IonFooter className="bg-white px-4 py-3 border-0">
         <IonButton
                  expand="block"
                  type="button"
                  onClick={()=>handleSubmit()}
                  className="bg-[#3B82F6] rounded-2xl"
                >
                   {isLoading ? "Подождите..." : "Войти"}
                </IonButton>
      </IonFooter>
    </IonPage>
  );
};

export default AuthPage;
